import { endOfDay } from 'date-fns'

import { tokenDecode } from '@subaio/utils'

import type { UserAuth } from 'lib/store'

export const getUserAuth = (options?: { token: string; budgetId: string }): UserAuth => {
	const { exp, sub: userId, brandId } = tokenDecode(options?.token)
	if (!options || typeof exp !== 'number') {
		return { status: 'unauthenticated' }
	}

	const now = Date.now()

	const expiration = Math.min(exp * 1000, endOfDay(now).valueOf())

	if (expiration < now) {
		return { status: 'expired' }
	}

	return {
		status: 'authenticated',
		token: options.token,
		expiration,
		userId,
		brandId,
		budgetId: options.budgetId,
	}
}
